import { cn } from "@/lib/utils";

/*
 * The small pieces the passport overview is built from: a tab's count badge,
 * the segmented radio the value list and the changelog filter with, and a
 * label/value row of the summary rail.
 */

export function Count({ children, tone = 'zinc' }) {
    // Hidden from the tab's accessible name, which stays the bare label.
    return (
        <span
            aria-hidden="true"
            className={cn(
                'rounded-full px-1.5 py-[3px] text-[11px] leading-none tabular-nums',
                tone === 'amber' ? 'bg-amber-100 text-amber-800' : 'bg-zinc-100 text-zinc-600',
            )}
        >
            {children}
        </span>
    );
}

export function Segmented({ label, value, onChange, options }) {
    return (
        <div role="radiogroup" aria-label={label} className="inline-flex h-8 rounded-md bg-zinc-200/60 p-0.5 text-[12.5px] font-medium">
            {options.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    role="radio"
                    aria-checked={value === option.value}
                    disabled={option.disabled}
                    title={option.title}
                    onClick={() => onChange(option.value)}
                    className={cn(
                        'rounded-[5px] px-2.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zinc-900/15 disabled:cursor-not-allowed disabled:text-zinc-400 disabled:hover:text-zinc-400',
                        value === option.value ? 'bg-white text-zinc-900 shadow-sm ring-1 ring-zinc-950/5' : 'text-zinc-600 hover:text-zinc-900',
                    )}
                >
                    {option.label}
                    {option.count !== undefined && <span className="ml-1 tabular-nums text-zinc-400" aria-hidden="true">{option.count}</span>}
                </button>
            ))}
        </div>
    );
}

export function RailRow({ label, children }) {
    return (
        <div className="flex items-baseline justify-between gap-3">
            <dt className="text-zinc-500">{label}</dt>
            <dd className="text-right text-zinc-900">{children}</dd>
        </div>
    );
}
